module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gp-30b1d26cfe9f458611e26248fadb490c.svg";